import { useState } from "react"

import { Button } from "web/components"
import useAutoFocusInput from "web/hooks/behaviour/useAutoFocusInput"

export default function CreateModal({ respond, kind, collection, addParams }) {
  const [inputValue, setInputValue] = useState("")
  const [errors, setErrors] = useState({})
  const { inputRef } = useAutoFocusInput()

  function handleKeyUp(e) {
    const enterKey = 13

    if (e.code === enterKey) {
      handleAdd()
    }
  }

  async function handleAdd() {
    try {
      const response = await collection.add({
        name: inputValue,
        ...addParams,
      })
      respond(response)
    } catch (error) {
      setErrors(error.response.data)
    }
  }

  return (
    <>
      <div className="modal-content-above-commands dialog-prompt">
        <div>{`What would you like to call the new ${kind}?`}</div>
        <div className="mt-1.5 w-full">
          <input
            type="text"
            ref={inputRef}
            className="form-control"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyUp={handleKeyUp}
          />
        </div>
        {errors && "name" in errors && (
          <div className="text-sm italic text-red-500">
            {errors["name"].join(" ,")}.
          </div>
        )}
      </div>
      <div className="modal-commands">
        <div className="left-buttons">
          <Button onClick={handleAdd}>Add</Button>
          <Button variant="tertiary_default" onClick={respond}>
            Cancel
          </Button>
        </div>
      </div>
    </>
  )
}
